import * as yup from 'yup';
import Validations from 'enums/schemaValidations/validations.enum';

const editAuditSchema = yup.object().shape({
  auditId: yup.string(),
  transactionId: yup.string(),
  merchantName: yup.string(),
  preferredContactEmail: yup
    .string()
    .email(Validations.PreferredContactEmailInvalid),
  auditCode: yup
    .number()
    .transform((val) => (Number.isNaN(val) ? -1 : val))
    .required(Validations.RequiredAuditCode),
  auditDescription: yup.string(),
  issuer: yup.string(),
  status: yup
    .mixed()
    .oneOf(['IN_PROGRESS', 'CLOSED'], Validations.StatusWhenEditing)
    .required(Validations.RequiredStatus),
  resolutionCode: yup
    .number()
    .nullable()
    .transform((value) => (Number.isNaN(value) ? undefined : value)),
  resolutionDescription: yup.string(),
  resolutionTimeStamp: yup.string(),
});

export { editAuditSchema };
